import { render } from "./Logout.vue?vue&type=template&id=0ac80d30"
import script from "./Logout.vue?vue&type=script&lang=ts"
export * from "./Logout.vue?vue&type=script&lang=ts"
script.render = render

export default script